const ROLES = {
  PROPERTY_DEVELOPER: 'Property Developer',
  HOME_OWNER: 'Home Owner',
  ADMIN: 'Admin',
} as const;

export { ROLES };
